// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5ea6815a","150":"00e9669c","422":"ccbd79fe","472":"378d8334"}[chunkId] + ".chunk.js";
};